export default __webpack_public_path__ + "static/main-ed7262555bc7fc4f178d1a4d2d926b9f.jpg";